import { Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Category, Platform, Technology } from 'models';
import React from 'react';
import { LessonForm } from '../types';
import StepContainer from './StepContainer';

const TechnologyForm: React.FC = () => {
  const { setFieldValue } = useFormikContext();

  const handleHardwareSoftwareChange = (
    _: React.ChangeEvent<{}>,
    value: Technology | Technology[] | string | string[] | null,
  ) => {
    setFieldValue('techRequirements.technologies', value);
  };

  const handleCategoriesChange = (
    _: React.ChangeEvent<{}>,
    value: Category | Category[] | string | string[] | null,
  ) => {
    setFieldValue('techRequirements.categories', value);
  };

  const handlePlatformsChange = (
    _: React.ChangeEvent<{}>,
    value: Platform | Platform[] | string | string[] | null,
  ) => {
    setFieldValue('techRequirements.platforms', value);
  };

  return (
    <StepContainer>
      <Grid item>
        <Typography gutterBottom>
          Tell us about the technologies included in this lesson:
        </Typography>
      </Grid>
      <Grid item>
        <Field name="techRequirements.technologies">
          {({ field, meta, form }: FieldProps<LessonForm['techRequirements']['technologies']>) => (
            <Autocomplete<Technology, boolean, undefined, boolean>
              {...field}
              multiple
              id="hardware-software"
              options={Object.values(Technology)}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hardware/Software"
                  helperText={
                    meta.touched && Boolean(meta.error)
                      ? meta.error
                      : 'Besides a laptop or desktop computer, what paid hardware or software is required to complete this lesson?'
                  }
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={meta.touched && Boolean(meta.error)}
                />
              )}
              onChange={handleHardwareSoftwareChange}
              onBlur={(e) => {
                form.setFieldTouched('techRequirements.technologies', true);
                field.onBlur(e);
              }}
            />
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="techRequirements.categories">
          {({ field, meta, form }: FieldProps<LessonForm['techRequirements']['categories']>) => (
            <Autocomplete<Category, boolean, undefined, boolean>
              {...field}
              multiple
              id="categories"
              options={Object.values(Category)}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Categories"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  helperText={meta.touched && meta.error}
                  error={meta.touched && Boolean(meta.error)}
                />
              )}
              onChange={handleCategoriesChange}
              onBlur={(e) => {
                form.setFieldTouched('techRequirements.categories', true);
                field.onBlur(e);
              }}
            />
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="techRequirements.platforms">
          {({ field, meta, form }: FieldProps<LessonForm['techRequirements']['platforms']>) => (
            <Autocomplete<Platform, boolean, undefined, boolean>
              {...field}
              multiple
              id="platforms"
              options={Object.values(Platform)}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Platforms"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  helperText={meta.touched && meta.error}
                  error={meta.touched && Boolean(meta.error)}
                />
              )}
              onChange={handlePlatformsChange}
              onBlur={(e) => {
                form.setFieldTouched('techRequirements.platforms', true);
                field.onBlur(e);
              }}
            />
          )}
        </Field>
      </Grid>
    </StepContainer>
  );
};

export default TechnologyForm;
